// Copyright (c) Move Closer 2022.

import { Container } from '@movecloser/front-core'

import { IPatch, IVersionResolver, PossibleVersion } from './contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export abstract class Patch implements IPatch {
  public abstract apply (container: Container): void

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public cleanup (container: Container): void {
    //
  }

  public abstract shouldApply (appVersion: IVersionResolver, storedVersion: PossibleVersion): boolean
}
